import { tempHigh } from '@shared/clinical-logic/convert/calculations/temperatureLogic'

const V4_PANEL_GET_RESPONSE_PATH = 'v4/panel/getResponse';
const GENDER_PANEL_NAME = 'gender'
const GENERAL_SYMPTOMS_BODY_PANEL_NAME = 'general_symptoms_body'
const HEADACHE_PANEL_NAME = 'headache'
const VOMITING_PANEL_NAME = 'vomiting'

async function getResponseFromPanel(rootGetters, panelName, responseName) {
  let response;
  try {
    response = rootGetters[V4_PANEL_GET_RESPONSE_PATH](panelName, responseName)
  } catch (e) { /* silently fail (╥_╥) */ }

  return response
}

async function skipIfNotGender(rootGetters, genderRequired) {
  let shouldSkip = false;

  const genderResponse = await getResponseFromPanel(rootGetters, GENDER_PANEL_NAME, genderRequired);
  const genderSelected = genderResponse && genderResponse.selected;
  shouldSkip = !genderSelected;

  return shouldSkip;
}

export default {
  async skipIfNotPerformingRDT({ rootGetters, rootState, dispatch }, panel) {
    try {
      var response = rootGetters['v4/panel/getResponse']('rdt_choice', 'yes')
      if (!response.selected) {
        await dispatch('v4/panel/reset', panel.name, { root: true })
      }
      return !response.selected
    }
    catch (e) {
      console.log(e)
    }
  },

  async rdtStatus({ dispatch }, payload) {
    let status = await dispatch('v4/rdt/status', {}, { root: true })
    try {
      payload.responses.forEach(response => {
        if (response.value === status) {
          response.selected = true
        }
        else {
          response.selected = false
        }
      })
    }
    catch (e) { console.log(e) }

    if (status == 'expired' || status === 'invalid') {
      return false
    }

    return true
  },

  async skipPanel({ rootGetters }) {
    return true
  },
  async skipIfNoObservation({ rootGetters }) {
    return !rootGetters['v4/observation/ready']
  },
  async setRdtTimerStart({ rootGetters, dispatch }) {
    return dispatch('v4/rdt/startTimer', {}, { root: true })
  },
  async setRdtTimerEnd({ rootGetters, dispatch }) {
    var response = rootGetters['v4/panel/getResponse']('rdt_timer_capture', 'timestamp')
    return dispatch('v4/rdt/endTimer', response.value, { root: true })
  },
  async configureRDT({ rootGetters, dispatch }, panel) {
    return dispatch('v4/rdt/configure', panel.options, { root: true })
  },
  async skipIfOlderThanTwo({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value > 728)
    }
    catch (e) {}
    return result
  },
  async skipIfOlderThan1Day({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value > 1)
    }
    catch (e) {}
    return result
  },
  async skipIfHaveMosquitoNet({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('ih_acf_mosquito_net', 'no')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoSickChildOrANC({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('ih_acf_child_or_anc_present', 'not_present')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoInjectableInterest({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('integrate_injectable_interest', 'no')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoOralInterest({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('integrate_oral_interest', 'no')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotOral({ rootGetters }) {
    let result = false
    try {
      var new_method = rootGetters['v4/panel/get']('integrate_fp_new_method').responses.find(r => r.selected)
      if (new_method) result = (new_method.value !== 'oral')
      else {
        var old_method = rootGetters['v4/panel/get']('integrate_preferred_contraceptive').responses.find(r => r.selected)
        if (!old_method || (old_method.value !== 'oral')) result = true
      }
    }
    catch (e) {}
    return result
  },
  async skipIfNotInjectable({ rootGetters }) {
    let result = false
    try {
      var new_method = rootGetters['v4/panel/get']('integrate_fp_new_method').responses.find(r => r.selected)
      if (new_method) result = (new_method.value !== 'sayana_press')
      else {
        var old_method = rootGetters['v4/panel/get']('integrate_preferred_contraceptive').responses.find(r => r.selected)
        if (!old_method || (old_method.value !== 'sayana_press')) result = true
      }
    }
    catch (e) {}
    return result
  },
  async skipIfNotDiscontinuingBC({ rootGetters }) {
    let result = false
    try {
      let response = rootGetters['v4/panel/getResponse']('encounter_new_visit', 'no')
      let response2 = rootGetters['v4/panel/getResponse']('integrate_fp_new_method', 'discontinue')
      let response3 = rootGetters['v4/panel/getResponse']('birth_control_first_time', 'yes')
      result = !response.selected || !response2.selected || response3.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNewEncounterOrFirstBC({ rootGetters }) {
    let result = false
    try {
      let response = rootGetters['v4/panel/getResponse']('encounter_new_visit', 'no')
      let response2 = rootGetters['v4/panel/getResponse']('birth_control_first_time', 'yes')
      result = !response.selected || response2.selected
    }
    catch (e) {}
    return result
  },
  async skipIfChangingMethodBC({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('encounter_new_visit', 'no')
      var response2 = rootGetters['v4/panel/getResponse']('integrate_fp_change_method', 'ih_method_change_0')
      result = !response.selected || response2.selected
    }
    catch (e) {}
    return result
  },
  async skipIfImplantOrIud({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('integrate_preferred_contraceptive', 'oral')
      var response2 = rootGetters['v4/panel/getResponse']('integrate_preferred_contraceptive', 'sayana_press')
      result = !(response.selected || response2.selected)
    }
    catch (e) {}
    return result
  },
  async skipIfPregnancyTestNotPositive({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('pregnancy_test_result', 'positive')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfPregnancyTestNotNegative({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('pregnancy_test_result', 'negative')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfWantToBePregnant({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('integrate_pregnancy_intent', 'no')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotDiscussingFamilyPlanning({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('integrate_discuss_family_planning', 'yes')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoHIV({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('hiv', 'yes')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIf3rdTrimester({ rootGetters }) {
    let result = false
    try {
      let due = new Date(rootGetters['v4/panel/getResponse']('due_date_display', 'date').value)
      let today = new Date()
      let oneDay = 24 * 60 * 60 * 1000
      let days_until_due = Math.round(Math.abs((due - today) / oneDay))
      console.log(days_until_due)
      result = days_until_due <= 90
    }
    catch (e) {}
    return result
  },
  async skipIfNot3rdTrimester({ rootGetters }) {
    let result = false
    try {
      let due = new Date(rootGetters['v4/panel/getResponse']('due_date_display', 'date').value)
      let today = new Date()
      let oneDay = 24 * 60 * 60 * 1000
      let days_until_due = Math.round(Math.abs((due - today) / oneDay))
      result = days_until_due > 90
    }
    catch (e) {}
    return result
  },
  async skipIfNotPregnant({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('encounter_patient_type', 'pregnant')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotNewMother({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('encounter_patient_type', 'new_mother')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  skipIfNotMaternal({ rootGetters }) {
    let shouldSkip = true
    try {
      const ageResponse = rootGetters['v4/panel/getResponse']('age', 'days')
      const femaleResponse = rootGetters['v4/panel/getResponse']('gender', 'female')
      shouldSkip = !(femaleResponse.selected && ageResponse.value >= 5475)
    }
    catch (e) {}
    return shouldSkip
  },
  async skipIfYoungerThan15OrByPhone({ rootGetters }) {
    let result = false
    try {
      var response1 = rootGetters['v4/panel/getResponse']('age', 'days')
      var response2 = rootGetters['v4/panel/getResponse']('encounter_experience', 'phone')
      var response3 = rootGetters['v4/panel/getResponse']('encounter_experience', 'self')
      result = (response1.value < 5475) || response2.selected || response3.selected
    }
    catch (e) {}
    return result
  },
  async skipIfOlderThan6Months({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value >= 182.5)
    }
    catch (e) {}
    return result
  },
  async skipIfYoungerThan15({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value < 5475)
    }
    catch (e) {}
    return result
  },
  async skipIfYoungerThan10({ rootGetters }) {
    let shouldSkip = false
    try {
      const ageResponse = rootGetters['v4/panel/getResponse']('age', 'days')
      shouldSkip = (ageResponse.value < 3650)
    }
    catch (e) {}
    return shouldSkip
  },
  async skipIfOlderThan15({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value > 5476)
    }
    catch (e) {}
    return result
  },
  async skipIfYoungerThan15OrNoCough({ rootGetters }) {
    let result = false
    try {
      const response = rootGetters['v4/panel/getResponse']('coughing_yesno', 'no')
      const response2 = rootGetters['v4/panel/getResponse']('coughing_yesno', 'unknown')

      const aResponse = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.selected || response2.selected || aResponse.value < 5475)
    }
    catch (e) {}
    return result
  },
  async skipIfNotFemaleOrYoungerThan10({ rootGetters }) {
    let shouldSkip = true
    try {
      const ageResponse = rootGetters['v4/panel/getResponse']('age', 'days')
      const femaleResponse = rootGetters['v4/panel/getResponse']('gender', 'female')
      shouldSkip = !(femaleResponse.selected && ageResponse.value >= 3650)
    }
    catch (e) {}
    return shouldSkip
  },
  skipIfNotFollowup({ rootGetters }) {
    let result = false
    try {
      const response = rootGetters['v4/panel/getResponse']('encounter_type', 'type1') // TODO adjust when text is finalized
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfAwake({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('disposition', 'sleeping')
      result = !!response.id && !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotIrritable({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('disposition', 'irritable')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoVomiting({ rootGetters }) {
    const vomitingYes = await getResponseFromPanel(rootGetters, VOMITING_PANEL_NAME, 'yes')
    if (vomitingYes && vomitingYes.selected) {
      // Vomiting positively reported on vomiting panel. Should NOT skip
      return false
    }

    const generalVomiting = await getResponseFromPanel(
      rootGetters,
      GENERAL_SYMPTOMS_BODY_PANEL_NAME,
      'vomiting'
    )
    if (generalVomiting && generalVomiting.selected) {
      // Vomiting positively reported on general symptoms body panel. Should NOT skip
      return false
    }

    return true
  },
  async skipIfNoDiarrhea({ rootGetters }) {
    let result = false
    try {
      let response = rootGetters['v4/panel/getResponse']('diarrhea_yesno', 'yes')
      result = (!response.selected)
    }
    catch (e) {}
    return result
  },
  async skipIfNoJaundice({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('jaundice', 'no')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfLessThan25WeeksPregnant({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('last_menstrual_period', 'date')
      var daysPregnant = Math.round((new Date() - new Date(response.value)) / (1000 * 60 * 60 * 24))
      result = daysPregnant < 175
    }
    catch (e) {}
    return result
  },
  async skipIfLessThan25WksPregOrNotConcernedBabyMovement({ rootGetters }) {
    let result = false
    try {
      var concernedResponse = rootGetters['v4/panel/getResponse']('baby_movement_concern', 'yes')
      var lmpResponse = rootGetters['v4/panel/getResponse']('last_menstrual_period', 'date')

      var daysPregnant = Math.round((new Date() - new Date(lmpResponse.value)) / (1000 * 60 * 60 * 24))
      result = !concernedResponse.selected || daysPregnant < 175
    }
    catch (e) {}
    return result
  },
  async skipIfNoVaginalDischarge({ rootGetters }) {
    const response = await getResponseFromPanel(rootGetters, 'vaginal_discharge', 'yes')
    const vaginalDischargePresent = response && response.selected
    return !vaginalDischargePresent
  },
  async skipIfNoAbdominalPain({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('abdominal_pain', 'yes')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoCough({ rootGetters }) {
    let result = false
    try {
      const response = rootGetters['v4/panel/getResponse']('coughing_yesno', 'no')
      const response2 = rootGetters['v4/panel/getResponse']('coughing_yesno', 'unknown')
      result = (response.selected || response2.selected)
    }
    catch (e) {}
    return result
  },
  async skipIfNoVaginalBleeding({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('vaginal_bleeding', 'yes')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoFever({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('recent_fever', 'yes')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoFeverOrHighTemperature({ rootGetters }) {
    try {
      const feverYes = rootGetters['v4/panel/getResponse']('recent_fever', 'yes')
      const temp = rootGetters['v4/panel/getResponse']('temperature', 'celsius')
      const age = rootGetters['v4/panel/getResponse']('age', 'days')

      const feverReported = feverYes && feverYes.selected
      const tempMeasured = temp && temp.value !== undefined && temp.value !== null && temp.value !== ''
      const highTemperature = tempMeasured && tempHigh(age && age.value, temp.value)

      return !(feverReported || highTemperature)
    }
    catch (e) {
      return false
    }
  },
  async skipIfRecentFever({ rootGetters }) {
    var response = await getResponseFromPanel(rootGetters, 'recent_fever', 'yes')

    return response && response.selected
  },
  async skipIfOlderThan12Months({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('age', 'days')
      result = (response.value > 365)
    }
    catch (e) {}
    return result
  },
  async skipIfNotSaved({ rootGetters }) {
    let result = false
    try {
      result = !rootGetters['v4/track/clickedSave']
    }
    catch (e) {}
    return result
  },
  async skipIfNotSleeping({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('disposition', 'sleeping')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async showOnlyIfModerateOrSevere({ state }) {
    let result = false
    try {
      result = (state.session.assessments.triage === 'moderate' || state.session.assessments.triage === 'severe')
    }
    catch (e) {}
    return result
  },
  async skipIfTempNotAbove37_5AndFeverNotChecked({ rootGetters }) {
    let result = false
    try {
      var tempResponse = rootGetters['v4/panel/getResponse']('temperature', 'celsius')
      var feverResponse = rootGetters['v4/panel/getResponse']('why_is_the_child_being_seen', 'fever')
      result = (!!tempResponse.value && tempResponse.value <= 37.5) || (tempResponse.value <= 37.5 && !feverResponse.selected)
    }
    catch (e) {}
    return result
  },
  async skipIfNoFeverOrTemperature({ rootGetters }) {
    let result = false
    try {
      const recentFeverYes = rootGetters['v4/panel/getResponse']('recent_fever', 'yes')
      result = !recentFeverYes.selected
    }
    catch (e) { console.log(e) }
    return result
  },
  async skipIfNotBeingReferred({ rootGetters }) {
    let result = true
    try {
      var response = rootGetters['v4/panel/getResponse']('encounter_patient_referred', 'yes')
      var triage = rootGetters['v4/panel/getResponse']('encounter_patient_triage', 'referred')

      if ((response && response.selected) || (triage && triage.selected)) {
        result = false
      }
    }
    catch (e) { console.log(e) }
    return result
  },
  async skipIfNotBeingReferredOrNurse({ rootGetters }) {
    let result = true
    try {
      let response = rootGetters['v4/panel/getResponse']('encounter_patient_referred', 'yes')
      let user = rootGetters['v4/panel/getResponse']('user_id', 'value')

      if ((response && response.selected) && (user && user.value && user.value.length === 4)) {
        result = false
      }
    }
    catch (e) { console.log(e) }
    return result
  },
  async skipIfMale({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('gender', 'male')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotFemale({ rootGetters }) {
    return skipIfNotGender(rootGetters, 'female');
  },
  async skipIfNotMale({ rootGetters }) {
    return skipIfNotGender(rootGetters, 'male');
  },
  async skipIfNotStreamlined({ rootGetters, commit }) {
    let result = false
    try {
      const response = rootGetters['v4/panel/getResponse']('streamlined_choice', 'streamlined')
      result = !response.selected

      if (result) {
        const state = {
          comprehensive: true, // setting comprehensive to true takes care of the condition and panel reset
          thresholdSet: null, // we did not reach a threshold set for comprehensive, so reset the state
        }
        commit('v4/track/setTrackForStreamlined', state, { root: true}) // use the existing mutation
      }
    }
    catch (e) {}
    return result
  },
  async skipIfTriageIsNone({ rootGetters }) {
    // used for careplan panel
    // content of function is actually "skip if no careplan items should be shown"
    let result = false
    try {
      result = !rootGetters['v4/mrx/hasCarePlansToShow']()
    }
    catch (e) {}
    return result
  },
  async skipIfNoTreatments({ rootState, rootGetters }) {
    let result = false
    try {
      const showAll = rootGetters['v4/mode/get']('showAllAssessments')
      const hasTreatments = rootGetters['v4/mrx/hasTreatmentsToShow']
      result = showAll || hasTreatments
    }
    catch (e) {}
    return !result
  },
  async skipIfNoSkinConcern({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('skin_concern', 'no')
      result = response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoMenstruation({ rootGetters }) {
    // only shows the amenorrhea panel if the patient SHOULD be menstruating but is not. 
    // If they ARE menstruating, or if they should NOT be menstruating at all (e.g., males),
    // the amenorrhea panel is skipped.
    const response = await getResponseFromPanel(rootGetters, 'menstruating', 'no')
    const shouldBeMenstruatingButIsNot = response && response.selected
    return !shouldBeMenstruatingButIsNot
  },
  async skipIfMenstruatingOrYoungerThan12({ rootGetters }) {
    const response = await getResponseFromPanel(rootGetters, 'menstruating', 'no')
    const shouldBeMenstruatingButIsNot = response && response.selected
    const ageResponse = rootGetters['v4/panel/getResponse']('age', 'days')
    const olderThanTwelve = (ageResponse.value >= 4380)

    return !(shouldBeMenstruatingButIsNot && olderThanTwelve);
  },
  async skipIfNewEncounter({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('encounter_new_visit', 'no')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNoHeadache({ rootGetters }) {
    let shouldSkip = false
    const headacheNone = await getResponseFromPanel(rootGetters, HEADACHE_PANEL_NAME, 'none')
    shouldSkip = headacheNone && headacheNone.selected

    if (!shouldSkip) {
      let headacheReported = false
      const headacheSeverities = ['mild', 'moderate', 'severe']

      for (const severity of headacheSeverities) {
        const headacheSeverityResponse = await getResponseFromPanel(
          rootGetters,
          HEADACHE_PANEL_NAME,
          severity
        )
        headacheReported = headacheSeverityResponse && headacheSeverityResponse.selected

        if (headacheReported) {
          break;
        }
      }

      shouldSkip = !headacheReported
    }

    return shouldSkip
  },
  async skipIfNotAccompaniedByBuddy({ rootGetters }) {
    let result = false
    try {
      var response = rootGetters['v4/panel/getResponse']('followup_accompanied', 'buddy')
      result = !response.selected
    }
    catch (e) {}
    return result
  },
  async skipIfNotEncouragedToSeek({ rootGetters }) {
    let result = false
    try {
      let response =  await getResponseFromPanel(rootGetters, 'encounter_encouragement', 'yes')
      result = !response.selected
    } catch (e) {}

    return result
  },
  async skipIfRDTNotNegative({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('rdt_status', 'negative')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfRDTNotInvalid({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('rdt_status', 'invalid')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfPerformingRDT({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('rdt_choice', 'no')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfSchoolDoesNotHaveMalariaTreatments({ rootGetters }) {
    let shouldSkip = true
    try {
      const careCategory2Response = rootGetters['v4/preference/getResponse']('expanded_care_category', 'category2')
      const schoolHasMalariaTreatment = careCategory2Response.selected
      const riskOfMalariaPresent = rootGetters['v4/mrx/hasRiskOfCondition']('malaria')
      const showMalariaPanels = schoolHasMalariaTreatment && riskOfMalariaPresent
      shouldSkip = !showMalariaPanels
    }
    catch (e) {}
    return shouldSkip
  },
  async skipIfMalariaTreatmentNotSelected({ rootGetters }) {
    try {
      // hardcoded treatment value for the following text:
      // "Coartem (Artemether 20mg / Lumefantrine 120mg) tablets"
      const response = rootGetters['v4/panel/getResponse']('treatments_administered', 'treatment17')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfNotPrescribedMedication({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('followup_prescribed_medication', 'yes')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfNotPrescribedAntibiotics({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('prescribed_medication_type', 'prescribed_medication_antibiotics')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async promptForRDTmrx2({ dispatch }) {
    let result = false
    try {
      var responses = await dispatch('v4/mrx/assess', { conditions: ['malaria'] }, { root: true })
      let assessment = responses.find(response => (response.name === 'malaria' && response.type === 'assessment'))
      result = (assessment.severity === 'moderate' || assessment.severity === 'severe')
    }
    catch (e) {}
    return result
  },
  async prefillGender({ rootGetters }) {
    let result = false
    try {
      let response1 = rootGetters['v4/panel/getResponse']('encounter_patient_type', 'pregnant')
      let response2 = rootGetters['v4/panel/getResponse']('encounter_patient_type', 'new_mother')
      let isFemale = response1.selected || response2.selected
      let track = rootGetters['v4/track/current']
      let genderPanel = track.panels.find(panel => panel.name === 'gender')
      Object.assign(genderPanel.options, { prefilled: isFemale, disabled: isFemale })
      if (isFemale) {
        genderPanel.responses.forEach(r => r.selected = false)
        genderPanel.responses.find(r => r.value === 'female').selected = true
      }
    }
    catch (e) {}
    return result
  },
  clearEncounterRegionDependentValues({ rootGetters, dispatch }) {
    try {
      let dependents = rootGetters['v4/preference/all']
        .filter(pref => pref.actions != null && pref.actions.filterResponses === 'filterByEncounterRegion')

      dependents.forEach(dependent => {
        dispatch('v4/preference/clearResponses', { panel: dependent }, { root: true })
      })
    }
    catch (e) {}
  },
  async skipIfNotPatientVaccination({ rootGetters }) {
    try {
      const response = rootGetters['v4/panel/getResponse']('patient_vaccination', 'yes')
      return !response.selected
    }
    catch (e) {}
    return true
  },
  async skipIfFeverDurationLessThan7({ rootGetters }) {
    let result = true
    try {
      const response = rootGetters['v4/panel/getResponse']('fever_duration', 'days')
      const duration = Number(response.value)
      result = response.unknown || !Number.isFinite(duration) || duration < 7
    }
    catch (e) {}
    return result
  }
}
